import React, { useEffect } from 'react';
import MtoLayout from './MtoLayout';
import { NavigatingAway } from './MtoNavigation';
import Sidebar from '../Sidebar/Sidebar';
import MtoMap from '../Map';
import { useMto } from '../context/MtoContext';

/**
 * MTO Main Page Component
 * Integrates all sub-components and functionality
 * Now using MtoContext for state management
 */
export default function MtoPage() {
  // Use MTO context for all state management
  const { 
    // Navigation
    goToHome,
    isNavigatingRef,
    initialize,
    
    // UI state
    showPanel,
    setShowPanel
  } = useMto();
  
  // Initialize component on mount
  useEffect(() => {
    initialize();
  }, [initialize]);

  // Check if navigating away
  if (isNavigatingRef.current) {
    return <NavigatingAway />;
  }

  return (
    <MtoLayout
      showPanel={showPanel}
      setShowPanel={setShowPanel}
      goToHome={goToHome}
      sidebar={<Sidebar />}
      map={<MtoMap />}
    />
  );
} 